import {
	aggregateGuideLinesByResidue,
	transformGuideDetailsToItemsByResidue,
} from './transformGuideDetailsToItemsByResidue';
import { guideLineSendResidueKey } from './warehouseGuideLinesSendAvailability';

function renumberLineNumbers(items) {
	return items.map((item, i) => ({ ...item, NroLinDet: i + 1 }));
}

function mergeGuideLineGroups(existingMv, incomingGroup) {
	const folios = [
		...new Set([
			...(existingMv.source_guide_folios || []),
			...(incomingGroup.source_guide_folios || []),
		]),
	];
	return {
		_is_warehouse_guide_lines_send: true,
		residue_id: incomingGroup.residue_id,
		residue: incomingGroup.residue ?? existingMv.residue,
		guide_detail_ids: [
			...(existingMv.guide_detail_ids || []),
			...incomingGroup.guide_detail_ids,
		],
		original_guide_ids: [
			...(existingMv.original_guide_ids || []),
			...incomingGroup.original_guide_ids,
		],
		individual_kilograms: [
			...(existingMv.individual_kilograms || []),
			...incomingGroup.individual_kilograms,
		],
		source_guide_folios: folios,
		kilograms_total:
			Number(existingMv.kilograms_total || 0) +
			Number(incomingGroup.kilograms_total || 0),
	};
}

/**
 * Fusiona líneas del modal NP en ítems del generador (agrupados por residuo).
 */
export function mergeGuideDetailSendItems(existingItems, linesFromModal) {
	const existing = Array.isArray(existingItems) ? [...existingItems] : [];
	const aggregated = aggregateGuideLinesByResidue(linesFromModal);

	if (aggregated.length === 0) {
		return {
			items: renumberLineNumbers(existing),
			stats: { merged: 0, added: 0 },
		};
	}

	const incomingByResidue = new Map(
		aggregated.map(g => [guideLineSendResidueKey(g.residue_id), g]),
	);

	let mergedCount = 0;
	const next = [];

	for (const item of existing) {
		const mv = item._module_vars || {};
		const key =
			mv._is_warehouse_guide_lines_send && mv.residue_id
				? guideLineSendResidueKey(mv.residue_id)
				: null;
		if (key && incomingByResidue.has(key)) {
			const inc = incomingByResidue.get(key);
			const mergedMv = mergeGuideLineGroups(mv, inc);
			const line = transformGuideDetailsToItemsByResidue(
				{
					residue_id: mergedMv.residue_id,
					residue: mergedMv.residue,
					kilograms_total: mergedMv.kilograms_total,
					source_guide_folios: mergedMv.source_guide_folios,
					guide_detail_ids: mergedMv.guide_detail_ids,
					original_guide_ids: mergedMv.original_guide_ids,
					individual_kilograms: mergedMv.individual_kilograms,
				},
				1,
			);
			next.push(line);
			incomingByResidue.delete(key);
			mergedCount += 1;
		} else {
			next.push(item);
		}
	}

	let addedCount = 0;
	for (const group of incomingByResidue.values()) {
		const line = transformGuideDetailsToItemsByResidue(group, next.length + 1);
		next.push(line);
		addedCount += 1;
	}

	return {
		items: renumberLineNumbers(next),
		stats: { merged: mergedCount, added: addedCount },
	};
}
